import { BACKEND_URL_PREFIX } from '../utils/const'
import { buildDefaultHeaders } from './helper'
import { checkAndUpdateToken } from './auth'
import { createNotification } from '../components/notifications/notifications'
import {
  NETWORK_REQUEST_SENT,
  TEACHER_SCHEDULE_YEARS_FETCHED,
  TEACHER_SCHEDULE_WEEKS_FETCHED,
  TEACHER_SCHEDULE_TERMS_FETCHED,
  TEACHER_SCHEDULE_LESSONS_FETCH_STARTED,
  TEACHER_SCHEDULE_LESSONS_FETCHED,
  TEACHER_SCHEDULE_LESSONS_FETCH_FAILED,
  TEACHER_SCHEDULE_RESET,
} from './types'

/* Режим «Личное расписание преподавателя» — только на чтение: пять GET-методов,
   изменяющих нет. Преподаватель в параметрах не передаётся, сервер берёт его
   из сеанса.

   Адрес собирается при вызове, а не при загрузке модуля: `utils/const` тянет
   `Routes`, `Routes` — компонент режима, а тот — этот файл, и на момент его
   инициализации `BACKEND_URL_PREFIX` из ещё не достроенного `utils/const`
   пустой — запрос уходил на `/undefined/teacher-schedule/...`. */
const url = path => `${BACKEND_URL_PREFIX}/teacher-schedule${path}`

const get = async (dispatch, getState, path) => {
  await dispatch(checkAndUpdateToken())
  if (!getState().auth.token) return null

  const response = await fetch(url(path), buildDefaultHeaders(getState))
  dispatch({ type: NETWORK_REQUEST_SENT, response })

  return response.ok ? response.json() : null
}

export const getYears = () => async (dispatch, getState) => {
  const data = await get(dispatch, getState, '/years')
  dispatch({ type: TEACHER_SCHEDULE_YEARS_FETCHED, payload: (data && data.years) || [] })
}

// перечень недель и перечень периодов хранятся вместе с учебным годом, которому
// они принадлежат: иначе после смены года на неделю подставлялась бы неделя
// прошлого перечня, пока не пришёл новый
export const getWeeks = yearId => async (dispatch, getState) => {
  const data = await get(dispatch, getState, `/years/${yearId}/weeks`)
  dispatch({
    type: TEACHER_SCHEDULE_WEEKS_FETCHED,
    payload: { yearId, weeks: (data && data.weeks) || [] },
  })
}

export const getTerms = yearId => async (dispatch, getState) => {
  const data = await get(dispatch, getState, `/years/${yearId}/terms`)
  dispatch({
    type: TEACHER_SCHEDULE_TERMS_FETCHED,
    payload: { yearId, terms: (data && data.terms) || [] },
  })
}

export const getLessons = weekId => async (dispatch, getState) => {
  dispatch({ type: TEACHER_SCHEDULE_LESSONS_FETCH_STARTED })

  const data = await get(dispatch, getState, `/weeks/${weekId}/lessons`)
  if (!data) {
    dispatch({ type: TEACHER_SCHEDULE_LESSONS_FETCH_FAILED, payload: weekId })
    return
  }

  dispatch({ type: TEACHER_SCHEDULE_LESSONS_FETCHED, payload: { weekId, ...data } })
}

/* Данные выписки нужны один раз — чтобы собрать документ, — поэтому в состоянии
   не хранятся: метод отдаёт их вызвавшему. Без права «Отчётность» → «Выписка по
   преподавателю» сервер отвечает 403, и режим при этом продолжает работать. */
export const getStatement = termId => async (dispatch, getState) => {
  try {
    return await get(dispatch, getState, `/terms/${termId}/statement`)
  } catch (err) {
    createNotification('error', 'Не удалось получить данные выписки')
    return null
  }
}

export const resetTeacherSchedule = () => ({ type: TEACHER_SCHEDULE_RESET })
